import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ZoomFrame } from '@/components/ui/zoomable-image'
import MediaUploadInput from '../MediaUploadInput'
import ImagesDatabase from '../ImageDatabase'
import { getAssetLink } from '../../../../../helpers/get-asset-link'

const ImageInput = ({
  columnSize,
  name,
  value,
  eventName,
  eventType,
  setFieldValue,
  isError = false,
  assetPath = 'chitown-images/training',
  fallback = 'training_image.png',
}) => {
  const { t } = useTranslation(['eventManagement'])
  const [isImageDatabaseOpen, setIsImageDatabaseOpen] = useState(false)

  if (typeof value === 'string') {
    const imageLink = getAssetLink({ path: assetPath, file: value, fallback })
    return (
      <div className="event-form-image-preview-container">
        <ZoomFrame src={imageLink} title={eventName}>
          <img src={imageLink} />
        </ZoomFrame>
        <button className="button button-black" onClick={() => setFieldValue('image', null)}>
          {t('eventManagement:common.change')}
        </button>
      </div>
    )
  }

  return (
    <div className={`column is-${columnSize}`}>
      <label className={`label ${isError ? 'is-danger' : ''}`}>
        {t('eventManagement:common.uploadEventTypePhoto', { eventType })}
      </label>
      {isImageDatabaseOpen ? (
        <ImagesDatabase
          eventName={eventName}
          handleFieldChange={(e) => setFieldValue(name, e.target.value)}
          toggleImageDatabase={setIsImageDatabaseOpen}
        />
      ) : (
        <MediaUploadInput
          value={value}
          handleFieldChange={(e) => setFieldValue(name, e.target.value)}
          toggleImageDatabase={setIsImageDatabaseOpen}
          isError={isError}
        />
      )}
    </div>
  )
}

ImageInput.propTypes = {
  columnSize: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.object,
  eventName: PropTypes.string.isRequired,
  eventType: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isError: PropTypes.bool,
  assetPath: PropTypes.string,
  fallback: PropTypes.string,
}

export default ImageInput
